export default {
  pushFormSegment: {
    marginTop: 40,
  },
};
